import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { AuthToken } = useAuth();
  if (!AuthToken) {
    return <Navigate to="/login" />;
  }
  return children;
};
